module.exports = __webpack_public_path__ + "static/favicon-f7651b0c840f00459abdc71aa732803e.ico";